import { get } from "../appStorage";
import { ACCESS_TOKEN_STORAGE } from "../../common/constant";

const isAuthenticated = () => {
  const accessToken = window.localStorage.getItem(ACCESS_TOKEN_STORAGE);
  return accessToken !== null && accessToken !== "";
};

export default isAuthenticated;
